"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingPreferencesOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var MarketingPreferencesOutputWidget = exports.MarketingPreferencesOutputWidget = /** @class */ (function (_super) {
    __extends(MarketingPreferencesOutputWidget, _super);
    function MarketingPreferencesOutputWidget(props) {
        var _a;
        var _this = this;
        var _b, _c;
        _this = _super.call(this, props) || this;
        _this.renderMarketingPreferenceCheckboxes = function (preferences) {
            return preferences.map(function (value) { return (React.createElement("label", { className: "".concat(value.className, "-preference") },
                React.createElement("input", { type: "checkbox", name: value.type, id: value.type, checked: _this.state.chkBoxStates[value.type], onClick: function () { return _this.updateChkBoxState(value.type); } }),
                React.createElement("div", { className: "checkbox" },
                    React.createElement("span", { className: "icon ".concat(value.icon || value.className, "-icon") }),
                    React.createElement("span", { className: "text font-weight-semi-bold" }, value.label)))); });
        };
        _this.updateChkBoxState = function (key) {
            var chkBoxState = _this.state.chkBoxStates[key];
            _this.setState(function (prevState) {
                var updatedChkBox = __assign({}, prevState.chkBoxStates);
                updatedChkBox[key] = !chkBoxState;
                return { chkBoxStates: updatedChkBox };
            }, function () {
                _this.props.onStateChange("policyHolder.marketingPreferencesSMS", _this.state.chkBoxStates[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_SMS]);
                _this.props.onStateChange("policyHolder.marketingPreferencesEmail", _this.state.chkBoxStates[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_EMAIL]);
                _this.props.onStateChange("policyHolder.marketingPreferencesPost", _this.state.chkBoxStates[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_POST]);
                _this.props.onStateChange("policyHolder.marketingPreferencesPhone", _this.state.chkBoxStates[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_PHONE]);
                _this.changelogRecorder.recordQuestion("change", _this.props);
            });
        };
        _this.preferenceType = _this.getSetting("preferenceType", undefined);
        if ((_c = (_b = _this.props.interaction.paymentDetails) === null || _b === void 0 ? void 0 : _b.instalmentPlan) === null || _c === void 0 ? void 0 : _c.instalmentPlanParameters) {
            _this.cancellationFee = _this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.cancellationFee;
        }
        else {
            _this.cancellationFee = _this.preferenceType === "home" ? "30" : "40";
        }
        var policyHolder = _this.props.interaction.policyHolder;
        _this.state = {
            chkBoxStates: (_a = {},
                _a[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_EMAIL] = policyHolder[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_EMAIL],
                _a[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_SMS] = policyHolder[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_SMS],
                _a[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_PHONE] = policyHolder[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_PHONE],
                _a[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_POST] = policyHolder[services_1.PartyPropertyEnum.MARKETING_PREFERENCES_POST],
                _a)
        };
        _this.checkboxes = [
            { type: services_1.PartyPropertyEnum.MARKETING_PREFERENCES_EMAIL, label: 'Email', className: 'email' },
            { type: services_1.PartyPropertyEnum.MARKETING_PREFERENCES_SMS, label: 'SMS', className: 'sms' },
            {
                type: services_1.PartyPropertyEnum.MARKETING_PREFERENCES_PHONE,
                label: 'Phone',
                className: 'phone',
                icon: 'smartphone'
            },
            { type: services_1.PartyPropertyEnum.MARKETING_PREFERENCES_POST, label: 'Post', className: 'post' },
        ];
        return _this;
    }
    MarketingPreferencesOutputWidget.prototype.render = function () {
        return (React.createElement("div", { className: "widget marketing-widget home" },
            React.createElement("div", { className: "inner-container marketing-preference" },
                React.createElement("div", { className: "panel-detail-output-entity account-details-title" },
                    React.createElement("h2", { className: "pl-3 dashboard-panel-title" }, "Marketing preferences")),
                React.createElement("div", { className: "panel-detail-output-entity text-left" },
                    React.createElement("div", { className: "widget marketing-widget" },
                        React.createElement("div", null,
                            React.createElement("p", { className: "margin-bottom-32" },
                                React.createElement("b", null, "Would you like to hear about our latest offers,\u00A0 products and discounts?"),
                                " You can opt in or out at any time from your account.")),
                        React.createElement("p", { className: "font-weight-bold" }, "How do you want to be contacted?"),
                        React.createElement("div", { className: "checkBox" }, this.renderMarketingPreferenceCheckboxes(this.checkboxes)),
                        React.createElement("div", null,
                            React.createElement("p", null, "Just so you know, if you don\u2019t opt in to our emails, we won\u2019t be able to send you our newsletter with offers, prizes and useful info about your products.."))))),
            React.createElement("div", { className: "marketing-widget home right-to-cancel" },
                React.createElement("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18" }, "Right to Cancel"),
                React.createElement("div", null,
                    React.createElement("p", null, "If you cancel before your policy starts no charges will be made."),
                    React.createElement("p", null,
                        "If you cancel within ",
                        React.createElement("b", null, "14 days"),
                        " of purchasing your policy (the cooling off period) - we'll refund any money you've paid minus a charge for the number of days you've had cover. A refund will still be paid if you've made a claim. You won't have to pay cancellation fee."),
                    (this.preferenceType === "annual") &&
                        React.createElement("p", null,
                            "If you cancel after 14 days of purchasing your policy, we'll refund any money you've paid minus a charge for the number of days you've had cover and a cancellation charge of ",
                            React.createElement("b", null,
                                "\u00A3",
                                this.cancellationFee,
                                "."),
                            "\u00A0 A refund will not be paid if you've made a claim."),
                    (this.preferenceType === "home") &&
                        React.createElement("p", null,
                            "If you cancel after 14 days of purchasing your policy, we'll refund any money you've paid minus a charge for the number of days you've had cover and a cancellation charge of ",
                            React.createElement("b", null,
                                "\u00A3",
                                this.cancellationFee,
                                "."),
                            "\u00A0 A refund will not be paid if you've made a claim.")))));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], MarketingPreferencesOutputWidget.prototype, "changelogRecorder", void 0);
    return MarketingPreferencesOutputWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=MarketingPreferencesOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/MarketingPreferencesOutputWidget.js
// module id = 3645
// module chunks = 0